export default __webpack_public_path__ + "static/media/home-yoga-meditation-meditation-bg.221581bf.jpg";